/* global $ */

import "../../css/pages/homepage.scss";
import "../../css/pages/cms-page.scss";
import loadComponentCarousel from "../modules/component-carousel/load-component-carousel";
import SetupReadmore from "../modules/readmore/readmore";
import { lighthouseImprovements } from "../modules/utility-functions/utility-functions";
import { gaTracking } from '../modules/event/event';

function init() {
	console.log("You are on the homepage");
	loadComponentCarousel();
	SetupReadmore();
	lighthouseImprovements();
	promoTracking();	
	appSplashSkip();
};

const promoTracking = () => {
	const banners = document.querySelectorAll<HTMLElement>('.custom-banner');
	banners.forEach(banner => {
		banner.querySelectorAll<HTMLLinkElement>('a')?.forEach(link => {
			link.addEventListener('click', e => {
				e.preventDefault();
				const target = (e.target as HTMLElement).closest('a');
				const title = target.getAttribute('title') || "No title added";
				const btnLink = target.getAttribute('href') || "No link added";

				gaTracking("view_promotion", false, {
					promotion_id: `Homepage: ${btnLink}`,
					promotion_name: title
				});

				gaTracking("select_promotion ", false, {
					promotion_id: `Homepage: ${btnLink}`,
					promotion_name: title
				});

				setTimeout(() => { location.href = btnLink; }, 100);
			});
		})
	});
};

const appSplashSkip = () => {
	const appSplash = document.querySelector<HTMLElement>('.app-splash-carousel');
	if (!appSplash) return;

	const setSplashVisible = (visible: boolean) => {
		appSplash.classList.toggle('visible', visible);
		document.documentElement.classList.toggle('app-splash-open', visible);
		document.body.classList.toggle('app-splash-open', visible);
	};

	if (sessionStorage.getItem("skipSplash") == 'true') setSplashVisible(false);
	else setSplashVisible(true);

	setTimeout(() => {	
		const skipBtns = document.querySelectorAll<HTMLElement>('.slide-skip');
		skipBtns?.forEach(skip => {
			skip.addEventListener('click', () => {
				setSplashVisible(false);
				sessionStorage.setItem("skipSplash", "true");
			});
		})
	}, 3000);
};

const exit = () => {
	console.log("Homepage: Exit");
};

window.homepage = {
	init,
	exit,
};
